export const APP_BUILD_INFO = {
  "appName": "webapp-react",
  "deployVersion": "v0.1+32.3c742af",
  "displayVersion": "v0.1+32",
  "builtAt": "2026-06-02T15:43:21.959Z",
  "buildNumber": "32",
  "commitSha": "3c742af",
  "gitBranch": "master",
  "packageVersion": "0.1.0"
} as const
